import {
    Component,
    OnInit,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AlertService } from '../../../core/services/alert/alert.service';
import { AlertMessage } from '../../../core/services/alert/models/alert-message';
import { AlertCardComponent } from '../alert-card/alert-card.component';

@Component({
    selector: 'app-alert-manager',
    templateUrl: './alert-manager.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertCardComponent],
})
export class AlertManagerComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    alerts: AlertMessage[] = [];

    constructor(private readonly alertService: AlertService) {}

    ngOnInit(): void {
        this.alertService.alerts$
            .pipe(takeUntil(this.destroy$))
            .subscribe((alerts) => {
                this.alerts = alerts;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Calling the alert service to remove an alert by GUID
     * @param guid - The GUID of the alert to remove
     */
    removeAlert(guid: string): void {
        this.alertService.removeAlert(guid);
    }
}
